import { useMemo } from "react";
import { compact } from "lodash";
import { useIsPaywallCustomizationPhase2 } from "@/react/hooks/useIsPaywallCustomizationPhase2";
import { tabs } from "../../../constants";
import type { TabOption } from "../../types";

type PaywallFormTab = (typeof tabs)[keyof typeof tabs];

interface UsePaywallFormContentEditFlowReturn {
  handleTabClick: (tab: PaywallFormTab) => void;
  shouldBlockSubmitButton: boolean;
  tabOptions: TabOption[];
}

export interface UsePaywallFormContentEditFlowProps {
  setActiveTab: (tab: PaywallFormTab) => void;
}

export const usePaywallFormContentEditFlow = ({
  setActiveTab,
}: UsePaywallFormContentEditFlowProps): UsePaywallFormContentEditFlowReturn => {
  const handleTabClick = (tab: PaywallFormTab): void => {
    setActiveTab(tab);
  };

  const isPhase2Enabled = useIsPaywallCustomizationPhase2();

  const tabOptions = useMemo(
    () =>
      compact([
        {
          label: tabs.DETAILS_TAB,
        },
        {
          label: tabs.PRICING_TAB,
        },
        {
          label: tabs.ACCESS_TAB,
        },
        isPhase2Enabled ? { label: tabs.CHECKOUT_TAB } : null,
        {
          label: tabs.POST_PURCHASE_TAB,
        },
        {
          label: tabs.TRACKING_TAB,
        },
        {
          label: tabs.WORKFLOWS_TAB,
        },
      ]),
    [isPhase2Enabled],
  );

  return {
    handleTabClick,
    tabOptions,
    shouldBlockSubmitButton: false,
  };
};
